import React, { FC } from 'react';
import { DocumentsDataGrid } from './components/DocumentsDataGrid';
import { InspectionPageTab } from '../types';

export const Documents: FC<InspectionPageTab> = ({ inspection }) => {
  return <DocumentsDataGrid inspection={inspection} />;
};
